<div class="modal-header bg-white border-bottom border-2 p-4">
  <h5 class="modal-title d-flex align-items-center fw-semibold fs-5" id="saveCalculatorModalLabel">
    <i class="fas fa-save me-2 text-primary-pink"></i>
    Salva Calcolatore
  </h5>
  <button type="button" class="btn-close opacity-50" aria-label="Close" (click)="cancel()" [disabled]="isSaving"></button>
</div>

<div class="modal-body p-4">
  <!-- Alert per errori -->
  <div class="alert alert-danger rounded-3 border-0 d-flex align-items-center" role="alert" *ngIf="error">
    <i class="fas fa-exclamation-triangle me-2"></i>
    <div>{{ error }}</div>
  </div>

  <!-- Form -->
  <form [formGroup]="saveForm" (ngSubmit)="save()">
    <div class="mb-4">
      <mdb-form-control>
        <input mdbInput type="text" id="titolo" class="form-control form-control-lg" formControlName="title" placeholder="Es: Mutuo Casa Milano" maxlength="100" [disabled]="isSaving" />
        <label mdbLabel class="form-label" for="titolo">Titolo *</label>
      </mdb-form-control>
      <div class="form-text small text-muted2">Scegli un nome descrittivo per questo calcolo</div>
    </div>

    <mdb-form-control>
      <textarea mdbInput id="message" class="form-control form-control-lg" formControlName="description" placeholder="Es: Calcolo per acquisto prima casa in zona Porta Romana" rows="6" maxlength="500" [disabled]="isSaving"></textarea>
      <label mdbLabel class="form-label" for="message">Descrizione <span class="text-muted fw-normal small">(opzionale)</span></label>
    </mdb-form-control>
    <div class="form-text small text-secondary">Aggiungi dettagli per ricordare il contesto di questo calcolo</div>
  </form>
</div>

<div class="modal-footer p-3 px-4 border-top bg-light d-flex justify-content-end gap-2">
  <button type="button" class="btn btn-light bg-white text-secondary" (click)="cancel()" [disabled]="isSaving">
    <i class="fas fa-times me-1"></i>
    Annulla
  </button>
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="isSaving || saveForm.invalid">
    <i class="fas" [class.fa-save]="!isSaving" [class.fa-spinner]="isSaving" [class.fa-spin]="isSaving"></i>
    <span class="ms-1">{{ isSaving ? 'Salvataggio...' : 'Salva' }}</span>
  </button>
</div>
